<template>
    <div class="products-aside" ref="productsAside" :class="{ 'products-aside-opened': isMenuOpened }">
        <p class="products-mobile-main-item" :class="{ 'products-mobile-main-item-active' : isMenuOpened }" @click="toggleMenu()">Всички продукти</p>
        <!-- <li v-if="!title" class="aside-title"><span class="strong">{{title}}</span></li> -->
        <ul v-if="this.$route.params.category == 'rolled-foils'" class="products-aside-ul">
            <li class="products-aside-li" :class="{ 'products-aside-li-active': isMenuOpened }" v-for="(product, index) in products" :key="'rolled-' + index" v-if="product.category === 'rolled-foils'">
                <router-link @click.native="itemSelected" class="products-aside-item" active-class="products-aside-item-active" :to="`/products/rolled-foils/${product.url}`">{{product.name}}</router-link>
            </li>
        </ul>
        <ul v-if="this.$route.params.category == 'rolled-sheets-and-strips'" class="products-aside-ul">
            <li class="products-aside-li" :class="{ 'products-aside-li-active': isMenuOpened }" v-for="(product, index) in products" :key="'rolled-' + index" v-if="product.category === 'rolled-sheets-and-strips'">
                <router-link @click.native="itemSelected" class="products-aside-item" active-class="products-aside-item-active" :to="`/products/rolled-sheets-and-strips/${product.url}`">{{product.name}}</router-link>
            </li>
        </ul>
        <ul v-if="this.$route.params.category == 'extruded'" class="products-aside-ul">
            <li class="products-aside-li" :class="{ 'products-aside-li-active': isMenuOpened }" v-for="(product, index) in products" :key="'extruded-' + index" v-if="product.category === 'extruded'">
                <router-link @click.native="itemSelected" class="products-aside-item" active-class="products-aside-item-active" :to="`/products/extruded/${product.url}`">{{product.name}}</router-link>
            </li>
        </ul>
        <!-- SEE ALSO -->
        <ul class="products-aside-ul see-also">
            <li class="products-aside-li">
              <span class="strong see-also-text">ВИЖ ОЩЕ</span>
            </li>
            <li class="products-aside-li" v-if="this.$route.params.category !== 'rolled-foils'">
                <router-link class="products-aside-item" :to="`/products/rolled-foils/household-foil`">Валцови изделия - Фолио</router-link>
            </li>
            <li class="products-aside-li" v-if="this.$route.params.category !== 'rolled-sheets-and-strips'">
                <router-link class="products-aside-item" :to="`/products/rolled-sheets-and-strips/standard-sheets-and-strips`">Валцови изделия - Листи и Ленти</router-link>
            </li>
            <li class="products-aside-li" v-if="this.$route.params.category !== 'extruded'">
                <router-link class="products-aside-item" :to="`/products/extruded/profiles-for-building-and-architecture`">Пресови изделия</router-link>
            </li>
        </ul>
    </div>
</template>

<script>
import Products from "./products.json";
import Aside from "../shared/Aside";
export default {
  components: {
    appAside: Aside
  },
  data() {
    return {
      products: Products,
      isMenuOpened: false
    };
  },
  methods: {
    toggleMenu() {
      this.isMenuOpened = this.isMenuOpened === false ? true : false;
    },
    itemSelected() {
      if (window.innerWidth < 1000) {
        // for mobile
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      } else {
        // for desktop
        window.scrollTo({
          top: this.$refs.productsAside.offsetTop - 100,
          behavior: "smooth"
        });
      }
      this.isMenuOpened = false;
    }
  }
};
</script>

<style scoped>
.products-aside {
  margin-right: 6%;
  padding-top: 15px;
  padding-bottom: 30px;
  width: 25%;
}
.products-aside-ul {
  padding: 10px 0 20px 0;
  border-right: 1px solid #c5d7e4;
}
.products-aside-li {
  display: block;
  text-align: right;
}
.products-aside-title {
  color: #00305b;
  display: block;
  font-size: 16px;
  padding: 15px 42px 15px 0;
  text-align: right;
}
.products-aside-item {
  border-right: 6px solid transparent;
  display: block;
  font-size: 16px;
  height: 100%;
  padding: 11px 36px 11px 11px;
}
.products-aside-item:hover {
  border-right: 6px solid #00305b;
  color: #00305b;
}
.products-aside-item-active {
  border-right: 6px solid #00305b;
  color: #00305b;
  font-weight: 700;
}
.see-also {
  background-color: #f8fafc;
  margin-top: 20px;
  padding: 10px 0;
}
.see-also-text {
  display: block;
  padding: 10px 42px 10px 0;
}
.products-mobile-main-item {
  display: none;
}
@media screen and (max-width: 1280px) {
  .products-aside {
    margin-right: 0;
  }
}
@media screen and (max-width: 1000px) {
  .see-also {
    display: none;
  }
  .products-aside {
    background-color: rgba(0, 71, 133, 0.98);
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    border: 2px solid #fff;
    border-bottom: none;
    bottom: 0;
    left: 48px;
    max-height: calc(100vh - 90px);
    min-height: 50px;
    padding: 0;
    position: fixed;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: calc(100% - 96px);
    z-index: 9;
  }
  .products-aside::after {
    color: #fff;
    content: "M";
    font-size: 18px;
    font-family: "alcomet";
    height: 20px;
    position: absolute;
    right: 20px;
    top: 15px;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    width: 20px;
  }
  .products-aside-opened {
    z-index: 9;
  }
  .products-aside-opened::after {
    transform: rotate(-180deg);
  }
  .products-mobile-main-item {
    align-items: center;
    color: #fff;
    font-size: 18px;
    display: flex;
    height: 50px;
    padding: 0 20px;
    position: relative;
    width: 100%;
    z-index: 1;
  }
  .products-mobile-main-item-active {
    display: none;
  }
  .products-aside-ul {
    border: none;
    max-height: calc(100vh - 140px);
    overflow: auto;
    padding: 0;
  }
  .products-aside-li {
    height: 0px;
    opacity: 0;
    overflow: hidden;
    -webkit-transition: all 0.4s ease;
    -moz-transition: all 0.4s ease;
    -ms-transition: all 0.4s ease;
    -o-transition: all 0.4s ease;
    transition: all 0.4s ease;
    text-align: left;
    position: relative;
    z-index: 1;
  }
  .products-aside-li-active {
    height: 50px;
    opacity: 1;
  }
  .products-aside-item {
    align-items: center;
    border: none;
    color: #fff;
    display: flex;
    font-size: 18px;
    padding: 0 20px;
    text-transform: initial;
  }
  .products-aside-item:hover {
    border: none;
    color: #fff;
  }
}
@media screen and (max-width: 600px) {
  .products-mobile-main-item,
  .products-aside-item {
    font-size: 16px;
  }
  .products-aside-li:first-of-type .products-aside-item {
    padding-right: 50px;
  }
}
@media screen and (max-width: 440px) {
  .products-aside {
    left: 30px;
    width: calc(100% - 60px);
  }
  .products-mobile-main-item,
  .products-aside-item {
    font-size: 13px;
  }
}
@media screen and (max-width: 380px) {
  .products-mobile-main-item,
  .products-aside-item {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/Aside.vue